import { Routes } from 'common/routeConfig'
import { useDataContext } from 'context/DataContext'
import { Link } from 'react-router-dom'

const Footer = () => {
    const { metaInfo } = useDataContext()
    const calculationDate = metaInfo?.calculationDate?.trim()

    return (
        <footer className="footer">
            <div className="footer__logoContainer">
                <div className="footer__logo" />
            </div>

            <div className="footer__linkContainer">
                <Link to={Routes.IFU}>Instructions for use</Link>
                <Link to={Routes.DISCLAIMER}>Disclaimer</Link>
            </div>

            {calculationDate && (
                <div className="footer__calculationDate">
                    Calculation date: {calculationDate}
                </div>
            )}
        </footer>
    )
}

export default Footer